import { SxProps } from '@mui/material';
import theme, { globalSectionPadding } from '@theme/index';

const { palette, spacing } = theme;

const tabStyle = {
  padding: spacing(0.5),
  borderRadius: '0.25rem',
  cursor: 'pointer'
};

const styles: Record<string, SxProps> = {
  container: {
    paddingX: globalSectionPadding,
    paddingTop: spacing(2),
    maxWidth: '140rem',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  // tabs
  tabContainer: {
    '& .MuiTabs-indicator': {
      display: 'none'
    },

    '.MuiTabs-flexContainer': {
      display: 'flex',
      flexDirection: 'row'
    },
    width: '100%',
    backgroundColor: palette.primary[400],
    alignItems: 'center',
    display: 'flex',
    borderRadius: '8px',
    padding: {
      xs: `0 0 0 ${spacing(0.5)}`,
      md: spacing(0.5)
    },
    position: 'relative',
    '& .MuiTabs-scroller': {
      paddingLeft: 0,
      width: { xs: '90vw', sm: '100%' },
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiTabs-scrollButtons': {
      width: '1.75rem',
      height: '100%',
      zIndex: 1,
      position: 'absolute',
      top: 0,
      backgroundColor: palette.primary[400]
    },

    '& .MuiTabs-scrollButtons:first-child': {
      left: 0
    },
    '& .MuiTabs-scrollButtons:last-child': {
      right: 0
    }
  },
  tabPill: {
    ...tabStyle,
    color: palette.primary.main,
    textTransform: 'none',
    minHeight: {
      md: '3rem',
      xs: '2.25rem'
    },
    height: {
      md: '3rem',
      xs: '2.25rem'
    }
  },
  selectedTabPill: {
    ...tabStyle,
    backgroundColor: palette.grey[50],
    borderRadius: '0.25rem',
    color: `${palette.primary.main} !important`,
    border: `0.0625rem solid ${palette.secondary[600]}`,
    textTransform: 'none',
    cursor: 'default',
    minHeight: {
      md: '3rem',
      xs: '2.25rem'
    },
    height: {
      md: '3rem',
      xs: '2.25rem'
    },
    pointerEvents: 'none'
  }
};

export default styles;
